module.exports = __webpack_public_path__ + "static/media/Aleo-LightItalic.10db35be.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Aleo-LightItalic.eot
// module id = 2921
// module chunks = 70